import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Slide,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';

import WalletsDuck from '../../../ducks/WalletsDuck';
import VirtualTransactionDuck from '../../../ducks/VirtualTransactionDuck';
import { openSnackbar } from '../../../components/Notifier';

const styles = (theme) => ({
  prompt: {
    marginBottom: theme.spacing.unit,
  },
  formControl: {
    marginBottom: theme.spacing.unit,
  },
});

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class CreateVirtualTransactionModal extends Component {
  state = {
    currency: '',
    amount: '',
    isSubmitting: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.open === true && this.props.open === false) {
      const currency = Math.random() < 0.5 ? 'AAR' : 'HKD';
      const precision = currency === 'AAR' ? 10000 : 100000000;
      const amount = ~~(Math.random() * precision) / precision;
      this.setState({
        currency,
        amount,
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        TransitionComponent={Transition}
        aria-labelledby="Create virtual transaction"
        onClose={this.handleClose}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          Create virtual transaction
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.prompt}>
            Please specify the amount and currency of the transaction:
          </DialogContentText>
          <FormControl fullWidth className={classes.formControl}>
            <InputLabel htmlFor="currency">Currency</InputLabel>
            <Select
              value={this.state.currency}
              onChange={(event) =>
                this.setState({ currency: event.target.value })
              }
              inputProps={{
                name: 'currency',
                id: 'currency',
              }}
            >
              <MenuItem value={'AAR'}>AAR</MenuItem>
              <MenuItem value={'HKD'}>HKD</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Amount"
            type="text"
            fullWidth
            value={this.state.amount}
            onChange={(event) => this.setState({ amount: event.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {this.state.currency}
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.handleClose}
            color="default"
            disabled={this.state.isSubmitting}
          >
            Cancel
          </Button>
          <Button
            onClick={this.createVirtualTransaction}
            color="primary"
            disabled={this.state.isSubmitting}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  handleClose = () => {
    this.props.hideVirtualTransactionModal();
  };

  createVirtualTransaction = () => {
    const {
      token,
      fromWalletExternalReferenceId,
      toWalletExternalReferenceId,
    } = this.props;
    const { amount, currency } = this.state;
    this.setState({ isSubmitting: true });
    this.props
      .submitVirtualTransaction({
        token,
        fromWalletExternalReferenceId,
        toWalletExternalReferenceId,
        amount,
        currency,
      })
      .then(
        ({ value: virtualTransaction }) => {
          console.log('@adding virtual tx ', virtualTransaction);
          this.props.addVirtualTransaction({ virtualTransaction });
          openSnackbar({
            message: 'Virtual Transaction successfully created.',
          });
          this.setState({ isSubmitting: false });
          this.props.hideVirtualTransactionModal();
        },
        () => {
          openSnackbar({ message: 'An error occurred, please try again.' });
          this.setState({ isSubmitting: false });
        },
      );
  };
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    fromWalletExternalReferenceId:
      state.virtualTransaction.fromWalletExternalReferenceId,
    toWalletExternalReferenceId:
      state.virtualTransaction.toWalletExternalReferenceId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    submitVirtualTransaction: ({
      token,
      fromWalletExternalReferenceId,
      toWalletExternalReferenceId,
      amount,
      currency,
    }) => {
      return dispatch(
        VirtualTransactionDuck.creators.submitVirtualTransaction({
          token,
          fromWalletExternalReferenceId,
          toWalletExternalReferenceId,
          amount,
          currency,
        }),
      );
    },
    addVirtualTransaction: ({ virtualTransaction }) => {
      return dispatch(
        WalletsDuck.creators.addVirtualTransactions({
          virtualTransactions: [virtualTransaction],
        }),
      );
    },
    hideVirtualTransactionModal: () => {
      return dispatch(
        VirtualTransactionDuck.creators.hideVirtualTransactionModal(),
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(CreateVirtualTransactionModal));
